// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__10M1Y","colBig":"styles_colBig__1OJoo","colSmall":"styles_colSmall__3nTuW","shopifyNameWrapper":"styles_shopifyNameWrapper__3_1wX"};